import { render } from "./JournalLinkPanel.vue?vue&type=template&id=466e7a14"
import script from "./JournalLinkPanel.vue?vue&type=script&lang=js"
export * from "./JournalLinkPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__